import {errorTypes} from '../../constants';
import {ravenCaptureException} from '@epic-core/common';
import ErrorView from '../error/ErrorView';
import React, {PureComponent} from 'react';

export interface ErrorProps {
    children: any;
    errorView?: any;
}

class ErrorBoundary extends PureComponent<ErrorProps> {
    state = {
        hasError: false
    };

    componentDidCatch(error) {
        ravenCaptureException(error);

        // Display fallback UI
        this.setState({hasError: true});
    }

    render() {
        const {children, errorView} = this.props;
        const {hasError} = this.state;
        if (hasError) {
            return errorView || <ErrorView type={errorTypes.CLIENT_ERROR} />;
        }
        return children;
    }
}

export default ErrorBoundary;
